module.exports = __webpack_public_path__ + "static/hector-Silva-4a96c1a94d05b1c5e30e369ef83dc9d4.png";